module.exports = __webpack_public_path__ + "img/fluent-megaphone-loud-filled.745be71a.svg";